import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';

import { interimApi } from 'api/InterimApi';

import { decimalIcdFormat, revertDecimalIcdFormat } from '../shared/ICD10Code/lib/formatICD';

export const handleCPTSearch = async (searchTerm, codes = [], navigate) => {
  if (searchTerm) {
    try {
      const params = {
        searchTerm,
        limit: 100
      };
      const res = await interimApi('/api/codes/cpt/get', params, navigate);
      if (res.data.cpt) {
        return res.data.cpt.map((item) => {
          const label = item.name ? `${item.code} - ${item.name}` : `${item.code}`;
          return {
            value: item.code,
            label
          };
        });
      } else {
        HoneybadgerErrorBoundary.notify(
          `There's been an unexpected error, please try again later.`
        );
      }
    } catch (err) {
      Honeybadger.notify(`There's been an unexpected error, please try again later. ${err}`);
    }
  } else if (codes.length > 0) {
    return codes.map((item) => {
      return { value: item, label: item };
    });
  }
};

export const handleICD10Search = async (searchTerm, codes = [], navigate) => {
  const removeDecimalFormat = revertDecimalIcdFormat(searchTerm);

  if (removeDecimalFormat) {
    try {
      const params = {
        searchTerm: removeDecimalFormat,
        limit: 100
      };
      const res = await interimApi('/api/codes/icd10/get', params, navigate);
      if (res.data.icd10) {
        return res.data.icd10.map((item) => {
          return {
            value: item.code,
            label: decimalIcdFormat({ data: { label: `${item.code} - ${item.name}` } })?.label
          };
        });
      } else {
        Honeybadger.notify(`There's been an unexpected error, please try again later.`);
      }
    } catch (err) {
      Honeybadger.notify(`There's been an unexpected error, please try again later. ${err}`);
    }
  } else if (codes.length > 0) {
    return codes.map((item) => {
      return { value: item, label: item };
    });
  }
};

export const handleModifierSearch = async (searchTerm, codes = [], navigate) => {
  if (searchTerm) {
    try {
      const params = {
        searchTerm,
        limit: 100
      };
      const res = await interimApi('/api/codes/modifiers/get', params, navigate);
      if (res.data.modifiers) {
        return res.data.modifiers.map((item) => {
          return { value: item.code, label: `${item.code} - ${item.name}` };
        });
      } else {
        Honeybadger.notify(`There's been an unexpected error, please try again later`);
      }
    } catch (err) {
      Honeybadger.notify(`There's been an unexpected error, please try again later. ${err}`);
    }
  } else if (codes.length > 0) {
    return codes.map((item) => {
      return { value: item, label: item };
    });
  }
};
